import { setAxiosInstanceHeader, setContactToken } from './network';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();


export const saveAuthTokenAndHeader = (token: string, expires_in: number): void => {
    cookies.set('auth', token, {path: '/', maxAge: expires_in });
    setAxiosInstanceHeader('Authorization', token);
    setContactToken(null);
};

export const removeAuthTokenAndHeader = (): void => {
    cookies.remove('auth', {path: '/'});
    setAxiosInstanceHeader('Authorization', '');
    setContactToken(null);
};

// query param з якого беремо токен (?token=TOKEN)
export const URL_AUTH_TOKEN_PARAM = 'token';
// токен з урла не має часу життя, тому ставимо дефолтний (7 днів)
const URL_AUTH_TOKEN_EXPIRES_IN = 60 * 60 * 24 * 7;

/**
 * Якщо в урлі є query param token (?token=TOKEN) — авторизує користувача
 * цим токеном і видаляє токен з урла.
 * Токен приходить без префіксу, тому додаємо Bearer.
 *
 * @returns true якщо токен був знайдений і застосований
 */
export const authorizeByUrlToken = (): boolean => {
    if (typeof window === 'undefined') return false;

    const url = new URL(window.location.href);
    const token = url.searchParams.get(URL_AUTH_TOKEN_PARAM);

    if (!token) return false;

    // створення кук і хедерів для авторизації
    saveAuthTokenAndHeader(`Bearer ${token}`, URL_AUTH_TOKEN_EXPIRES_IN);

    // видаляємо токен з урла без перезавантаження сторінки
    url.searchParams.delete(URL_AUTH_TOKEN_PARAM);
    window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);

    return true;
};
